import type { RootState } from "@src/store/rootState";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { getEmbeddedNodeFactory } from "@src/store/slices/experienceBuilder/common/selectors/getEmbeddedNodeFactory";

export const getOriginalHtmlFactory = (mod: EmbeddedMod) => {
  const getEmbeddedNode = getEmbeddedNodeFactory(mod);
  return (state: RootState) => {
    const node = getEmbeddedNode(state);
    return node?.html ?? "";
  };
};
